module.exports = __webpack_public_path__ + "img/slider_d03.40d971f.dbc03d34.png";